// เปลือกเว็บ (nav/footer/hamburger) ใช้ร่วมกับหน้า /articles ที่ render ฝั่ง server
import nextDynamic from 'next/dynamic';
import FooterQuick from './FooterQuick';

// staticAuth (เช่นทุกหน้า /articles/*) ไม่เรนเดอร์ตัวนี้เลย — โหลดแบบแยกชิ้นกันมัดรวม
// เข้า bundle ของหน้าที่ไม่ได้ใช้ (auth.js + toast.js + gameNavigation.js ~30KB)
const AuthWidget = nextDynamic(() => import('./AuthWidget'));

export const nav = [['/','หน้าแรก'],['/live','ดูบอลสด'],['/reviews','รีวิวและทดลองเล่นเกม'],['/promotions','โปรโมชั่น'],['/articles','บทความ'],['/contact','ติดต่อเรา']];

function StaticAuthActions() {
  return <div className="member-box" id="memberBox">
    <div className="auth-actions">
      <a className="nav-cta" href="/?auth=register" style={{textDecoration:'none'}}>สมัครสมาชิก</a>
      <a className="nav-login-btn" href="/?auth=login" style={{textDecoration:'none'}}>เข้าสู่ระบบ</a>
    </div>
  </div>;
}

export function Header({ page, logoSrc = '/assets/logo-ufathai.svg', staticAuth = false }) {
  return <header className="navbar" aria-label="เมนูหลัก">
    <input className="nav-checkbox" id="nav-menu-toggle" type="checkbox" autoComplete="off" aria-label="เปิดหรือปิดเมนู"/>
    <label className="nav-toggle nav-toggle-icon-only" data-nav-version="2" htmlFor="nav-menu-toggle"><i aria-hidden="true"><span/><span/><span/></i><span className="sr-only">เปิดหรือปิดเมนู</span></label>
    <a className="nb-logo" href="/" aria-label="UFATHAI หน้าแรก"><img src={logoSrc} alt="UFATHAI" width="390" height="65" decoding="async" /></a>
    <nav className="nb-links">{nav.map(([href,label]) => <a key={href} className={page === href ? 'active' : ''} href={href}>{label}</a>)}</nav>
    {staticAuth ? <StaticAuthActions /> : <AuthWidget />}
    <label className="nav-backdrop" htmlFor="nav-menu-toggle" aria-label="ปิดเมนู"/>
  </header>;
}

export function Footer({ staticAuth = false }) {
  return <><footer className="site-footer"><a className="ft-logo" href="/"><img src="/assets/logo-ufathai.svg" alt="UFATHAI" width="390" height="65" loading="lazy" decoding="async" /></a><nav className="ft-links">{nav.map(([h,l])=><a key={h} href={h}>{l}</a>)}<a href="/privacy-policy">นโยบายความเป็นส่วนตัว</a><a href="/terms">ข้อตกลงการใช้งาน</a><a href="/responsible-gaming">การเล่นอย่างรับผิดชอบ</a></nav><p className="ft-note">ใช้งานอย่างรับผิดชอบ · โปรดตรวจสอบกฎหมายและอายุขั้นต่ำในพื้นที่ของคุณ</p><p className="ft-copy">© UFATHAI · ยูฟ่าไทย</p></footer><FooterQuick staticAuth={staticAuth}/></>;
}

export function Shell({ page, children, blank=false, logoSrc, staticAuth=false }) {
  return <><Header page={page} logoSrc={logoSrc} staticAuth={staticAuth}/><main className={`site subpage${blank ? ' blank-page' : ''}`}>{children}</main><Footer staticAuth={staticAuth}/></>;
}
